<template>
  <!--
   v-if="detail.preview_water_pic"
   -->
  <div ref="scrollBox1" class="pic-wrap">

    <div class="pic-img-box">
      <template v-if="detail.home_keyword == 137 && detail.ppt_slide_show.length">
        <div class="PptSwiperBox">
          <PptSwiper :hot-list="detail.ppt_slide_show"/>
        </div>

      </template>

      <template v-else>

        <template v-if="spider">
          <img v-if="detail && detail.preview_water_pic"
               :src="'https://pic.chaopx.com' + detail.preview_water_pic + '!/fw/660/quality/90/unsharp/true/compress/true'"
               class="pic-img" @contextmenu.prevent="" alt="">
        </template>

        <template v-else>
          <a :href="customAHref" target="_blank" @click.prevent="">
            <img v-if="detail && detail.preview_water_pic"
                 :src="'https://pic.chaopx.com' + detail.preview_water_pic + '!/fw/660/quality/90/unsharp/true/compress/true'"
                 class="pic-img" @contextmenu.prevent="" alt="">
          </a>

        </template>


      </template>


      <TupianMask v-if="spider"/>
      <div class="mask" v-show="!isLogin"></div>
      <no-ssr>
        <LoginFloater class="LoginFloater"/>
      </no-ssr>
    </div>
    <i class="icon_badge icon_badge-big " :class="{ 'actPackage': detail.discount_act == 1 }"/>
    <div :class="[isFixed == true ? 'no' : 'on', { 'active': showImgPanel }]" class="pic-introduce-panel"
         ref="picIntroducePanel">
      <h1 v-if="detail.package === 1" class="panel-title overflow-more">{{ detail.title }}
      </h1>

      <div class="pic-package-num">{{ detail.pic_num - 1 }}张
      </div>
      <!-- 图片包下载按钮 -->
      <div class="pic-package-btn-group-wrap">

        <!-- 已购买 -->
        <div v-if="detail.is_buy == 1 || companyVipState == 1 || (businessVipState == 1 && businessVipInfo.vip == 5)"
             class="pic-package-btn-group pic-package-btn-group-buy">
          <div class="pic-package-btn buy-vip-btn buy-vip-btn-download" @click="download(1, detail.uniq_id)">原图打包下载
          </div>
          <div class="pic-package-btn buy-btn" @click="download(2, detail.uniq_id)">
            <!--            <i class="iconfont icon-pack"/>-->
            源文件打包下载
          </div>
        </div>

        <div v-else class="pic-package-btn-group">
          <div class="pic-package-btn buy-vip-btn buy-vip-btn-company" @click="navigatorToPay(PAY_COMPANY)">购买企业VIP
          </div>
          <!--            @click="showPayDialog">-->
          <div class="pic-package-btn buy-btn" @click="buyLeaflet">
            <!--            <i class="icon_dollar">￥</i>-->
            <!--            <span class="price">{{ detail.package_price | disposePrice }}</span>-->
            <span class="price">{{ '购买此包' }}</span>
            <span class="text">/{{ detail.pic_num - 1 }}张</span>
          </div>
        </div>

        <div :class="[isCollect == 1 ? 'like-btn-active' : 'like-btn-default']" class="like-btn _pointer "
             @click="toggleLike()">
          <i class="iconfont icon-collect4"/>
        </div>
      </div>


      <div class="invite-take">
        说明：图片包是系列套图的合集，目前支持两种下载方式：单独购买、企业VIP可免费下载。尊享商用授权、一键打包下载。
      </div>
      <!--      <InviteReceive class="InviteReceive" :entry="8"/>-->

      <ul class="panel-purpose _hide ">
        <li>
          <i class="iconfont icon-gou"/>
          <span class="label">下载范围：</span>
          <!--          <a
                      :href="PAGE_PATH.BASE_URL + PAGE_PATH.INTRODUCE.VIP"
                      target="_blank"
                      v-if="detail.layer != 4"
                      class="btn">个人</a>
                    <a
                      :href="PAGE_PATH.BASE_URL + PAGE_PATH.INTRODUCE.COMPANY_VIP"
                      target="_blank"
                      class="btn btn-company">企业</a>-->

          <!--          <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS" @click="tag('充值:详情页下载范围:图片:click')" target="_blank" class="legal-copy free"
                       v-if=" 1 >= detail.layer"
                    >免费下载</a>
                    <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS" @click="tag('充值:详情页下载范围:图片:click')" target="_blank" class="legal-copy person"
                       v-if="2 >= detail.layer "
                    >会员专享</a>-->
          <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.COMPANY" @click="tag('充值:详情页下载范围:图片:click')" target="_blank"
             class="legal-copy company">企业商用</a>
          <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.PAYMENT.BUSINESS" @click="tag('充值:详情页下载范围:图片:click')" target="_blank"
             class="legal-copy business">个人商用</a>

        </li>

        <li>
          <i class="iconfont icon-gou"/>
          <span class="label">授权方式：</span>
          <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.INTRODUCE.COMPANY_VIP" target="_blank" class="value">VRF授权</a>
        </li>
        <li>
          <i class="iconfont icon-gou"/>
          <span class="label">版权归属：</span>
          <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.INTRODUCE.COMPANY_VIP" target="_blank" class="value">潮国创意</a>
        </li>
      </ul>

      <DetailEquity/>
      <PicInfo v-bind="$attrs"/>

      <no-ssr>
        <!--        <VipUpgradePanel />-->
        <!--        <RelevancePic />-->
        <DetailFormatPanel :detail="detail"/>
        <PicReportModal :detail="detail"/>
      </no-ssr>


    </div>

    <!-- 下载限制弹框 -->
    <no-ssr>
      <DownloadInterceptDialog :time="clippingTime" ref="DownloadInterceptDialog"/>
    </no-ssr>


  </div>
</template>

<script>
import {IMG_BASE_URL, MEMBER_LICENSE_VIP, PAY} from "@/constant/PATH";
import {InviteReceive} from "@/components/act/invite";
import {mapState} from "vuex";
import {packageStat} from "@/api/stat";
import {DownloadInterceptDialog} from "@/components/material";
import {fnLogin, fnVip} from "@/fn";
import LoginFloater from '@/components/common/login/login-floater/login-floater.vue';
import PicReportModal from './pic-report-modal'
import {tag} from "~/utils/statUtil";
import {downStat} from "@/api/material";
import panelExtend from "@/components/tupian/detail/common/panelExtend";
import axios from 'axios'
import {toolDevice} from "@/tools";
import {PAGE_PATH} from '@/constant/PAGE_PATH'
import {HOME} from "@/constant/HOME";
import {BROWSERS} from "@/constant/SYSTEM";
import PicInfo from '@/components/tupian/detail/pic-info'
import {getCookie} from "@/utils/auth";
import * as CON_COMMON from "@/constant/_constant";
import * as fnCommon from "@/fn/_fn";

import PptSwiper from "@/components/_components/pic/detail/PptSwiper";
import FnUser from "@/fn/_fn/FnUser";
import {setPicFreeDownCouponModal} from "~/components/_Privately/Pic/PicFreeDownCouponModal/module";
import {PAY_COMPANY} from "@/constant/_Public/Path";

export default {
  name: "TuPianDetailPicPackagePanel",
  mixins: [panelExtend],

  props: {
    /* 详情 */
    detail: {
      type: Object,
      default: () => {
      }
    },
    /* 是否展示面板-动画效果判断 */
    showImgPanel: {
      type: Boolean,
      default: false
    },
    /* 是否收藏 */
    isCollect: {
      type: Number | String,
      default: 0
    },
    customAHref: ''

  },
  computed: {
    ...mapState('user', ['isLogin',
      'vipIsPerson',
      'vipIsBusiness',
      'personVipState',
      'personVipInfo',
      'businessVipState',
      'businessVipInfo',
      'companyVipState',
      'companyVipInfo',
      'isLogin',
      'companyAccountStatus',
    ]),
    ...mapState('base', ['spider']),
  },
  data() {
    return {
      MEMBER_LICENSE_VIP,
      IMG_BASE_URL,
      isFixed: true,
      clippingTime: '',
      PAGE_PATH,
      PAY_COMPANY,

      swiperOption: {
        autoplay: {
          delay: 5000,
          speed: 500,
        },
        //配置分页
        pagination: {
          el: '.swiper-pagination'//分页的dom节点
        },
        direction: "horizontal",
        initialSlide: 0, // 默认选中
        loop: true, // 在此无效？？？？？
        centeredSlides: true, //活动块居中
        slideToClickedSlide: false, // 点击切换
        lazy: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        on: {
          slideChange: () => {
            const c_swiper = document.getElementsByClassName("swiperPpt");
            this.swiperOption.initialSlide = c_swiper[0].swiper.activeIndex - 1;
            // this.swiperOption.initialSlide = c_swiper[0].swiper.activeIndex - 1;
            // console.log("轮播图滚动事件 --->",c_swiper[0].swiper.activeIndex)
            if (c_swiper[0].swiper.activeIndex - 1 > this.detail.ppt_slide_show.length - 1) {
              this.swiperOption.initialSlide = 0
            }
            if (c_swiper[0].swiper.activeIndex - 1 < 0) {
              this.swiperOption.initialSlide = this.detail.ppt_slide_show.length - 1
            }
          }
        }
      },
    }
  },
  components: {
    InviteReceive,
    DownloadInterceptDialog,
    LoginFloater,
    PicReportModal,
    PicInfo,
    PptSwiper
  },


  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    setTimeout(() => {
      this.handleScroll()
    }, 100)
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    tag(stat) {
      tag(stat)
    },
    picReport() {

    },
    showPayDialog() {
      packageStat({event: 'buy'});
      this.$emit('showPayDialog');
    },
    handleScroll() {

      if (!!this.$refs.scrollBox1 && !!this.$refs.picIntroducePanel) {
        let scrollTop = this.$refs.scrollBox1.getBoundingClientRect().bottom
        let height = this.$refs.scrollBox1.offsetHeight;
        this.isFixed = scrollTop >= this.$refs.picIntroducePanel.offsetHeight;
        this.$localStorage.setItem('isFixed', this.isFixed);
      }
    },

    toggleLike() {
      this.$emit('toggleLike');
    },

    showPayVipDialog() {
      this.$emit('showPayVipDialog')
    },


    download(channel, uniq_id) {

      if (fnLogin.checkLogin()) {

        let tempStr = `https://dl.chaopx.com/down/download?channel=${channel}&uniq_id=${uniq_id}&module=2`
        let route = this.$route

        if (route.query._topic_id) {
          tempStr = route.query._topic_id ? tempStr += `&topic_id=${route.query._topic_id}&refererUrl=${route.query._refererUrl}` : tempStr
        } else {
          tempStr += `&refererUrl=${document.referrer}`
        }

        axios.get(tempStr).then(res => {
          let {status, time, url, msg, free_down} = res.data.data;

          if (FnUser.checkCompanyVipExpiredModal()) {
            if (status == 0 || status == 2) {
              this.$store.commit('Modal/SET_COMPANY_VIP_EXPIRED_MODAL', true)
              return false;
            }
          }


          if (status === 1) {
            // window.location.href = url;
            packageStat({event: 'down', channel: channel})
            downStat({uniq_id: uniq_id, module: 2})
            if (free_down == 1) {
              setPicFreeDownCouponModal(this.$store, true);
            }

            if (toolDevice.getCurrentBrowser() === BROWSERS.Safari) {
              setTimeout(() => {
                window.location.href = url;
              }, 200)
            } else {
              window.location.href = url;
            }


          } else if (status === -200) {
            this.clippingTime = time;
            this.$refs.DownloadInterceptDialog.isShow = true;
          } else {
            this.$myNotify.show(msg)
          }
        });

      }

    },

    navigatorToPay(path) {
      if (fnLogin.checkLogin()) {
        tag('充值:商用VIP按钮:图片')
        this.isShowFreeDownload = false;
        window.open(path, '_blank')
      } else {
        this.$store.commit("user/SET_IS_SHOW_LOGIN", 1);
      }

    },

    buyLeaflet() {
      let path = CON_COMMON.CON_BASIC.PAY_LEAFLET + `/${this.detail.uniq_id}.html`;
      fnCommon.fnPay.dataTrackByClickLeaflet()
      fnCommon.fnBasic.navigationTo(path)
    }
  },
  filters: {

    disposePrice(val) {
      return parseFloat(val).toFixed(1);
    },

    iconClassHoverText(val) {
      switch (val) {
        case 'icon_ps':
          return 'Adobe Photoshop';
        case 'icon_3dMax':
          return '3D Max';
        case 'icon_cdr':
          return 'Coreldraw';
        case 'icon_ai':
          return 'Adobe lllustrator';
        case 'icon_c4d':
          return 'Cinema 4D';
        case 'icon_sketch':
          return 'Sketch App';
        case 'icon_blender':
          return 'Blender';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common/common";
@import "./styles/pic-report";

.invite-take {
  padding: 10px 15px;
  border-radius: 8px;
  position: relative;
  letter-spacing: 1px;
  box-sizing: border-box;
  margin-top: 20px;
  max-width: 435px;
  line-height: 20px;
  font-size: 13px;
  color: #0a2540;
  background: #f8f8fb;
  margin-bottom: 20px;
}

.pic-wrap {
  display: flex;
  margin-bottom: 112px;
  //padding-top: 45px;
  position: relative;
  z-index: 10;
  //transition: all 0.5s ease-in-out;


  .LoginFloater {
    position: absolute;
    z-index: 6;
  }

  .pic-img-box {
    position: relative;
    margin-right: 60px;
    width: 660px;

    .mask {
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 21%, #FFFFFF 100%);
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 14px;
      z-index: 6;
    }


    .PptSwiperBox {
      width: 660px;
      height: 864px;
      //overflow: hidden;
    }

    /*.swiper-box {
      width: 660px;
      height: 864px;
      position: relative;
      z-index: 999;

      .swiper {
        width: 100%;
        height: 100%;
        background: pink;

        .swiper-wrapper{
          //width: 100%;
          //height: 100%;
        }

        .swiper-img {
          width: 100%;
          height: 100%;
        }

      }
    }*/


  }

  .icon_badge {
    @include BgImage(110px, 106px, 'pic-package/icon_badge-big.svg');
    @include Position(1, 5, 0, 0px);
    //z-index: 99;
    z-index: 6;

    &.actPackage {
      @include BgImage(71px, 68px, 'act/guoqing/icon_badge.png');
      top: -4px !important;
    }
  }

  .pic-img {
    width: 660px;
    //height: 749px;
    border-radius: 14px;
    margin-right: 60px;
  }


  .pic-introduce-panel {
    background-color: #fff;
    margin-left: 750px;
    box-sizing: border-box;
    transition: all 0.5s ease-in-out;
    //min-height: 764px;
    opacity: 0;
    z-index: 998;

    &.active {
      opacity: 1;
    }

    &.on {
      position: absolute;
      bottom: 0;
    }

    &.no {
      position: fixed;
      //top: 170px;
    }


    .panel-title {
      //width: 434px;
      width: 100%;
      max-width: 434px;
      max-height: 74px;
      font-size: 28px;
      color: #0A2540;
      line-height: 37px;

      font-size: 22px;
      color: #0A2540;
      line-height: 29px;

    }

    .panel-author {
      height: 18px;
      font-size: 13px;
      color: #596088;
      line-height: 18px;
      letter-spacing: 1px;
      margin: 8px 0 24px;

    }

    .pic-package-num {
      font-size: 14px;
      color: #2D2B33;
      line-height: 20px;
      margin: 6px 0 24px;
    }

    .pic-package-btn-group-wrap {
      display: flex;
    }

    .pic-package-btn-group {
      display: flex;

      .pic-package-btn {
        width: 207px;
        height: 68px;
        border-radius: 14px;
        text-align: center;
        line-height: 64px;
        font-size: 18px;

        width: 167px;
        height: 64px;
        background: #6969FF;
        border-radius: 14px;
        box-sizing: border-box;
      }

      .buy-vip-btn {
        background: #6969FF;
        font-weight: bold;
        color: #FFFFFF;
        margin-right: 16px;

        @include ElementHover('', #5E5EE8);

        &.buy-vip-btn-download {
          color: #FCBE00;
          font-weight: bold;
          border: 1px solid #F8CC44;
          background-color: #fff;

          @include ElementHover('', rgba(248, 204, 68, 0.1)) {
          }

        ;
        }

        &.buy-vip-btn-company {
          background: $color-company;
          @include ElementHover('', $color-company-hover) {
          }
        }
      }

      .buy-btn {
        background: #F8CC44;
        font-size: 0;
        //padding: 10px 0;
        box-sizing: border-box;
        @include ElementHover('', #F8D568);
        display: flex;
        align-items: center;
        justify-content: center;

        .icon_dollar {
          font-size: 18px;
          font-weight: bold;
          color: #2D2B33;
          line-height: 24px;
          vertical-align: 3px;
        }

        .price {
          //font-size: 26px;
          font-size: 18px;
          font-weight: bold;
          color: #2D2B33;
          line-height: 40px;
          margin: 0 2px 0 0px;
        }

        .text {
          font-size: 13px;
          color: #2D2B33;
          line-height: 18px;
          vertical-align: 3px;
        }
      }
    }

    .pic-package-btn-group-buy {
      .buy-btn {
        padding: 0;
        font-size: 18px;
        font-weight: bold;
        color: #2D2B33;
        line-height: 64px;
        display: flex;
        justify-content: center;

        .icon-pack {
          font-size: 22px;
          color: #2D2B33;
          margin-right: 10px;
        }
      }
    }


    .panel-btn-group {
      display: flex;

      .download-btn {
        width: 350px;
        height: 64px;
        background: $color-primary;
        border-radius: 14px;
        font-size: 20px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 68px;
        box-sizing: border-box;
        letter-spacing: 1px;
        text-align: center;
        margin-right: 16px;
        @include ElementHover('', #5E5EE8);
      }

      .like-btn {
        width: 64px;
        height: 64px;
        box-sizing: border-box;
        border-radius: 14px;
        border: 1px solid #E0E3E9;
        @include LayoutFlex(1);

        i {
          font-size: 30px;
        }

        &.like-btn-default {
          background-color: #FFFFFF;
          @include ElementHover('', #EBEDF5);

          i {
            color: #424866;
          }
        }

        &.like-btn-active {
          background-color: #F8CC44;
          border-color: #F8CC44;
          @include ElementHover('', #DEB740);

          i {
            color: #FFFFFF;
          }
        }
      }
    }

    .panel-purpose {
      margin: 40px 0 32px;

      .legal-copy {
        width: 80px;
        text-align: center;
        height: 26px;
        line-height: 26px;
        border-radius: 14px;
        padding: 0 !important;
      }

      li {
        font-size: 18px;
        color: #001013;
        line-height: 20px;
        letter-spacing: 1px;
        margin-bottom: 18px;
        display: flex;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }

        > a {
          margin-right: 6px;
        }

        .iconfont {
          position: relative;
          top: 2px;
          margin-right: 10px;
          font-size: 22px;
          color: $color-primary;
        }

        .icon-shield {
          color: $color-primary;
        }

        .btn {
          display: inline-block;
          width: 50px;
          line-height: 26px;
          background: #6969FF;
          border-radius: 14px;
          color: #FFFFFF;
          font-size: 15px;
          text-align: center;
          margin-right: 8px;
          cursor: pointer;

          &.btn-company {
            background: linear-gradient(133deg, #434978 0%, #3D4266 100%);
            color: rgba(255, 229, 206, 1);
          }
        }

        .label {
          color: #424866;
          line-height: 22px;
          letter-spacing: 1px;
        }

        .value {
          font-size: 17px;
          color: #001013;
          line-height: 22px;
          letter-spacing: 1px;
          text-decoration: underline;
        }
      }

    }


  }
}

.like-btn {
  width: 64px;
  height: 64px;
  box-sizing: border-box;
  border-radius: 14px;
  border: 1px solid #E0E3E9;
  @include LayoutFlex(1);
  margin-left: 16px;

  i {
    font-size: 30px;
  }

  &.like-btn-default {
    background-color: #FFFFFF;
    @include ElementHover('', #EBEDF5);

    i {
      color: #424866;
    }
  }

  &.like-btn-active {
    background-color: #F8CC44;
    border-color: #F8CC44;
    @include ElementHover('', #DEB740);

    i {
      color: #FFFFFF;
    }
  }
}

.legal-copy {
  display: block;
  transition: all 0.5s ease-in-out;
  line-height: 28px;
  background: linear-gradient(213deg, #FFF1A4 0%, #FFC04D 100%);
  border-radius: 6px;
  font-size: 14px;
  color: #A45F00;
  padding: 0 8px;
  height: 28px;
  cursor: pointer;


  &.legal-copy-active {
    display: none;
    padding-right: 4px;
  }

  &.free {
    background: linear-gradient(145deg, #45A0FF 0%, #00C6FF 100%);
    color: #FFFFFF;
  }

  &.person {
    background: linear-gradient(129deg, #FD9C5D 0%, #FF5967 100%);
    color: #FFFFFF;
  }

  &.business {
    background: linear-gradient(213deg, #FFF1A4 0%, #FFC04D 100%);
    color: rgba(179, 77, 41, 1);
  }

  &.company {
    background: linear-gradient(133deg, #40456B 0%, #292C42 100%);
    color: rgba(250, 228, 178, 1);
  }
}
</style>
